export default function MarkIconDesc({ mark }) {
  if (!mark) return <div />;

  let colorStyle = 'default-bg';
  if (mark.startsWith('P')) colorStyle = 'green-bg';

  return (
    <div className={'mark-desc-icon-container ' + colorStyle}>
      <div className="mark-desc-icon-style">{mark}</div>
    </div>
  );
}
